import { TableHeaderType } from '@fullscreendigital/carrefour-dex-fe/dist/cjs/components/Table'

export const columns: Array<TableHeaderType> = [
  {
    title: '',
    field: 'supportCode',
    align: 'left'
  },
  {
    title: 'Tip ambalaj',
    field: 'supportTypeName',
    align: 'left'
  },
  {
    title: 'Număr  ambalaje',
    field: 'supportNumber',
    align: 'center'
  },
]
